import * as C from '../constants';
import TwentyService from '../../../services/twenty-service';
import i18n from '../../../i18n/index';

export default {

  /**
   * @param commit
   * @returns {Promise<T>}
   */
  xmlChannels({ commit }, type) {
    commit(C.XML_CHANNELS_LOAD_PENDING);
    return TwentyService.getXmlChannelsByType(type)
      .then((res) => {
        commit(C.XML_CHANNELS_LOAD_SUCCESS, res.data);
      })
      .catch(() => {
        commit(C.XML_CHANNELS_LOAD_FAILURE);
      });
  },

  /**
   * @param commit
   * @returns {Promise<T>}
   */
  xmlProducts({ commit }, type) {
    commit(C.XML_PRODUCTS_LOAD_PENDING);
    return TwentyService.getXmlProductsByType(type)
      .then((res) => {
        commit(C.XML_PRODUCTS_LOAD_SUCCESS, res.data);
      })
      .catch(() => {
        commit(C.XML_PRODUCTS_LOAD_FAILURE);
      });
  },

  /**
   * @param commit
   * @returns {Promise<any>}
   */
  brandsLoad({ commit }) {
    commit(C.TWENTY_BRANDS_LOAD_PENDING);
    return TwentyService.getAvailableBrands()
      .then((res) => {
        commit(C.TWENTY_BRANDS_LOAD_SUCCESS, res.data);
      })
      .catch((err) => {
        let errorMessage = i18n.t('errors.went-wrong');
        if (err.response && err.response.data) {
          errorMessage = err.response.data;
        }
        commit(C.TWENTY_BRANDS_LOAD_FAILURE, errorMessage);
      });
  },

  /**
   * @param commit
   * @param payload
   */
  brandsSet({ commit }, payload) {
    commit(C.TWENTY_BRANDS_CHANGE, payload);
  },

  /**
   * @param commit
   * @param payload
   * @returns {Promise<any>}
   */
  salesStatsLoad({ commit }, payload) {
    commit(C.TWENTY_SALES_STATS_LOAD_PENDING);
    return TwentyService.getBookingSalesStatistics(payload)
      .then((res) => {
        commit(C.TWENTY_SALES_STATS_LOAD_SUCCESS, res.data);
      })
      .catch((err) => {
        let errorMessage = i18n.t('errors.went-wrong');
        if (err.response && err.response.data) {
          errorMessage = err.response.data;
        }
        commit(C.TWENTY_SALES_STATS_LOAD_FAILURE, errorMessage);
      });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/twenty/actions.js